module.exports = __webpack_public_path__ + "f1f65b61c82cbc2faf821d0b4c45118d.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/team_philip_mobile_teaser.jpg
// module id = 674
// module chunks = 0